import { render, staticRenderFns } from "./record-info.vue?vue&type=template&id=45ec36c8&scoped=true&"
import script from "./record-info.vue?vue&type=script&lang=js&"
export * from "./record-info.vue?vue&type=script&lang=js&"
import style0 from "./record-info.vue?vue&type=style&index=0&id=45ec36c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ec36c8",
  null
  
)

export default component.exports